/** 默认主题：经典金 */
export const DEFAULT_THEME_ID = 'classic-gold';

/** 后台主题编码字段名 */
export const THEME_CODE_FIELD = 'themeCode';

/** @deprecated 使用 THEME_CODE_FIELD */
export const THEME_ID_FIELD = 'themeCode';

